import { createFileRoute } from '@tanstack/react-router';

import { validateMailSearch } from '../../../features/webmail/lib/search-params.ts';
import { WebmailPage } from '../../../features/webmail/webmail-page.tsx';
import { requirePermissionRoute } from '../../../lib/permissions.ts';

export const Route = createFileRoute('/_app/mail/$mailboxId/$folder')({
  validateSearch: validateMailSearch,
  beforeLoad: requirePermissionRoute('mail.use'),
  component: MailFolder,
});

function MailFolder() {
  const { mailboxId, folder } = Route.useParams();
  return <WebmailPage mailboxId={mailboxId} folder={folder} search={Route.useSearch()} />;
}
